import classNames from 'classnames';
import React from 'react';
import type { GanttProjectRow } from '../gantt-types';
import LeftClientCell from './LeftClientCell';
import styles from './LeftHeader.module.scss';
import LeftProjectCell from './LeftProjectCell';

interface Props {
  row: GanttProjectRow;
  isLastRow: boolean;
  style: React.CSSProperties;
  rowHeight: number;
  scrollTop: number;
  overflowClientToNext: boolean;
  displayClient: boolean;
}

const LeftProjectRow: React.FC<Props> = ({
  row,
  style,
  rowHeight,
  scrollTop,
  isLastRow,
  overflowClientToNext,
  displayClient,
}: Props) => {
  return (
    <div
      style={style}
      className={classNames(styles.leftHeaderRow, {
        [styles.lastRow]: isLastRow,
      })}
    >
      <div style={{ width: '40%', height: rowHeight }}>
        {displayClient && (
          <LeftClientCell
            row={row}
            style={style}
            isLastRow={isLastRow}
            overflowToNext={overflowClientToNext}
            rowHeight={rowHeight}
            scrollTop={scrollTop}
          />
        )}
      </div>
      <div style={{ width: '60%' }}>
        <LeftProjectCell
          row={row}
          style={style}
          isLastRow={isLastRow}
          rowHeight={rowHeight}
          scrollTop={scrollTop}
        />
      </div>
    </div>
  );
};
export default LeftProjectRow;
